import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import introVideo from './01-intro.webm';

export const slide = () => {
  return (
    <Slide notes="Eva presentation introduction" visualizer="hidden">
      <WebContent>
        <div className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="!fixed !inset-0 !m-0 !p-0 !w-screen !h-screen !max-w-none !max-h-none object-cover opacity-40"
            src={introVideo}
          />
        </div>
      </WebContent>
      <div className="relative z-10 flex flex-col items-center justify-center h-full">
        <h1 className="title">EVA</h1>
        <p className="subtitle">Enterprise Virtual Assistant</p>
        <p className="byline">by Jonathan IJzerman</p>
      </div>
    </Slide>
  );
};
